import doc                            from '@widesk-core/decorators/doc';
import model                          from '@widesk-core/decorators/model';
import ShopServiceModel               from '@/models/ShopServiceModel';
import TimestampAble                  from '@widesk-core/models/traits/TimestampAble';
import Blamable                       from '@/models/traits/Blamable';
import Translatable                   from '@widesk-core/models/traits/Translatable';
import ProductModel                   from '@/models/services/shop/ProductModel.ts';
import { SupportedLanguage }          from '@/hooks/useTranslations.tsx';

@model.urnResource('product_variant')
@doc.path('/product_variants/{?id}')
export default class ProductVariantModel extends Blamable(TimestampAble(Translatable(ShopServiceModel, {
	'title': true,
}))) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'product': id;
		'product.entertainment': id;
		'product.entertainment.entertainmentUrn': Urn;
		'product.productStatus': id;
		// 'product.productStatus.reference': ProductStatusReference;
		'product.productTaxonomies.taxonomy': id;
		'product.productType': id;
		// 'product.productType.reference': Shop_ProductTypeReference;
		'productVariantSalesStatus': id;
		// 'productVariantSalesStatus.reference': Shop_ProductVariantSalesStatusReference;
		'productVariantStatus': id;
		// 'productVariantStatus.reference': Shop_ProductVariantStatusReference;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'position': string;
		'product.entertainment.label': string;
		'updatedAt': string;
	};	

	@doc.date declare endDate: Dayjs;
	@doc.number declare maxQuantity: number;
	@doc.number declare position: number;
	@doc.model(ProductModel) declare product: ProductModel;
	// @doc.model(ProductVariantSalesStatusModel) declare productVariantSalesStatus: ProductVariantSalesStatusModel;
	// @doc.model(ProductVariantStatusModel) declare productVariantStatus: ProductVariantStatusModel;
	@doc.date declare startDate: Dayjs;

	public getTitle(language: SupportedLanguage) {
		return this.get(`translations.${language}.title`, '');
	}

	public getShortTitle(lang: SupportedLanguage) {
		return this.get(`translations.${lang}.shortTitle`, '');
	}

	public getFullTitle(lang: SupportedLanguage, short = false) {
		return [this.product.getTitle(lang), short ? this.getShortTitle(lang) : this.getTitle(lang)].filter(Boolean).join(' - ');
	}
}